import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AcceptInvite from "@/pages/AcceptInvite";
import OrganisationSettings from "@/pages/OrganisationSettings";
import PlatformOverview from "@/pages/PlatformOverview";
import Dashboard from "@/pages/Dashboard";
import NewExpense from "@/pages/NewExpense";
import ExpenseDetail from "@/pages/ExpenseDetail";
import PublicApproval from "@/pages/PublicApproval";
import PublicAudit from "@/pages/PublicAudit";
import VerifyAudit from "@/pages/VerifyAudit";
import UserGuide from "@/pages/UserGuide";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function PlatformRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!user.is_platform_admin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route path="/approve/:token" element={<PublicApproval />} />
            <Route path="/audit/:token" element={<PublicAudit />} />
            <Route path="/verify" element={<VerifyAudit />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/expenses/new" element={<ProtectedRoute><NewExpense /></ProtectedRoute>} />
            <Route path="/expenses/:id" element={<ProtectedRoute><ExpenseDetail /></ProtectedRoute>} />
            <Route path="/settings" element={<AdminRoute><OrganisationSettings /></AdminRoute>} />
            <Route path="/guide" element={<ProtectedRoute><UserGuide /></ProtectedRoute>} />
            <Route path="/platform" element={<PlatformRoute><PlatformOverview /></PlatformRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
